import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EmailComposePage from './pages/EmailComposePage';
import { ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import theme from './utils/themes';
import CssBaseline from '@mui/material/CssBaseline';
import Register from './pages/Register';
import { Layout } from './components/Layout';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Settings } from './pages/Settings';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './config/msalConfig';
import EmailAutomation from './pages/EmailAutomation';
import Dashboard from './pages/Dashboard';
import TermsAndConditions from './pages/TermsAndConditions';
import AcceptableUsePolicy from './pages/AcceptableUsePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import LandingPage from './pages/LandingPage';
import ExtensionPrivacy from './pages/ExtenstionPrivacy'
import InteractiveDemo from './pages/InteractiveDemo';
import Pricing from './pages/Pricing';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { PaymentCancelled } from './pages/PaymentCancelled';
import FAANGWatch from './pages/FAANGWatch';
import ResumeBuilder from './pages/ResumeBuilder';
import ForgotPassword from './pages/ForgotPassword';
import H1BDataExplorer from './pages/H1BDataExplorer';
import CompanySearchPage from './pages/CompanySearchPage';
import CompanyProblems from './components/CompanyPage';
import CompanyProblemTree from './components/CompanyProblemTree';
import CodeEditor from './components/CodeEditor/CodeEditor';
import MockInterview from './pages/MockInterview';
import MockInterviewSession from './pages/MockInterviewSession';
import './config.js';



export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <div style={{ margin: 0 }}>
          <CssBaseline />
          <ThemeProvider theme={theme}>
            <AuthProvider >
              <BrowserRouter>
                <Layout>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                    <Route path="/acceptableuse" element={<AcceptableUsePolicy />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/cookies" element={<CookiePolicy />} />
                    <Route path="/extension-privacy" element={<ExtensionPrivacy />} />
                    <Route path="/interactive-demo" element={<InteractiveDemo />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    <Route path="/payment-cancelled" element={<PaymentCancelled />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} /> {/* Add this new route */}
                    <Route
                      path="/new-application"
                      element={
                        <ProtectedRoute>
                          <EmailComposePage />
                        </ProtectedRoute>
                      }
                    />                {/* Add other routes as needed */}
                    <Route
                      path="/email-automation"
                      element={
                        <ProtectedRoute>
                          <EmailAutomation />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/h1b-data"
                      element={
                        <ProtectedRoute>
                          <H1BDataExplorer />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/settings"
                      element={
                        <ProtectedRoute>
                          <Settings />
                        </ProtectedRoute>
                      }
                    />

                    <Route
                      path="/email-automation/:id"
                      element={
                        <ProtectedRoute>
                          <EmailAutomation />
                        </ProtectedRoute>
                      }
                    />

                    <Route
                      path="/faang-watch"
                      element={
                        <ProtectedRoute>
                          <FAANGWatch />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/resume-builder"
                      element={
                        <ProtectedRoute>
                          <ResumeBuilder />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/companies"
                      element={
                        <ProtectedRoute>
                          <CompanySearchPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/company/:companyId"
                      element={
                        <ProtectedRoute>
                          <CompanyProblemTree />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/company/:companyId/problems"
                      element={
                        <ProtectedRoute>
                          <CompanyProblems />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/code-editor"
                      element={
                        <ProtectedRoute>
                          <CodeEditor />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/mock-interview"
                      element={
                        <ProtectedRoute>
                          <MockInterview />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/mock-interview/:questionId"
                      element={
                        <ProtectedRoute>
                          <MockInterviewSession />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </Layout>
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </div>
      </GoogleOAuthProvider>
    </MsalProvider>
  );
}

export default App;